import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "bt-icon bt-icon--xs" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "btn-stripped" }
const _hoisted_7 = { class: "p-field-label mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "fs-13 label-error",
  style: {"position":"absolute"}
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Password = _resolveComponent("Password")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.label), 1),
        _createVNode(_component_ElDropdown, {
          class: "ml-auto",
          trigger: "click",
          placement: "bottom-end",
          "popper-class": "el-dropdown__popper el-dropdown--context"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_ElDropdownMenu, { style: {"width":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ElDropdownItem, {
                  disabled: _ctx.disabled,
                  onClick: _ctx.codeGenerator
                }, {
                  default: _withCtx(() => [
                    _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.GenerateKeypadCode")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, { class: "p-button-rounded p-button-outlined ml-auto" }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                require(`@/assets/images/icons/icon-ellipsis-v.svg`)
                            ,
                    "aria-label": "icon-ellipsis"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.More")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCode")), 1),
      _createVNode(_component_Password, {
        disabled: _ctx.disabled,
        class: ["w-50", { 'w-100': _ctx.fullWidth }],
        toggleMask: "",
        feedback: false,
        maxlength: _ctx.keypadCodeRequiredLength,
        modelValue: _ctx.keypadCode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypadCode = $event)),
        inputClass: {
                'w-100': true,
                'input-error': _ctx.newCodeNotValid,
            },
        placeholder: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
        onBlur: _ctx.checkNewCodeValidation,
        onFocus: _ctx.resetNewCodeValidation
      }, null, 8, ["disabled", "maxlength", "modelValue", "inputClass", "class", "placeholder", "onBlur", "onFocus"]),
      _createVNode("div", null, [
        (_ctx.newCodeNotValid)
          ? (_openBlock(), _createBlock("label", _hoisted_8, _toDisplayString(_ctx.invalidNewCodeMessage), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeConfirmationUpper")), 1),
      _createVNode(_component_Password, {
        disabled: _ctx.disabled,
        toggleMask: "",
        id: 'codecheck_' + _ctx.labelId,
        maxlength: _ctx.keypadCodeRequiredLength,
        class: ["w-50", { 'w-100': _ctx.fullWidth }],
        feedback: false,
        modelValue: _ctx.codeCheck,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.codeCheck = $event)),
          _ctx.codeWasEdited
        ],
        inputClass: {
                'w-100': true,
                'input-error': _ctx.codeConfirmationNotValid,
                'input-valid': _ctx.codeConfirmationValid,
            },
        placeholder: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
        onBlur: _ctx.checkCodeConfirmationValid,
        onFocus: _ctx.resetConfirmValidation
      }, null, 8, ["disabled", "id", "maxlength", "modelValue", "inputClass", "class", "placeholder", "onUpdate:modelValue", "onBlur", "onFocus"]),
      _createVNode("div", null, [
        (_ctx.codeConfirmationValid)
          ? (_openBlock(), _createBlock("label", {
              key: 0,
              for: 'codecheck_' + _ctx.labelId,
              class: "fs-13 label-valid"
            }, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeConfirmationMatch")), 9, ["for"]))
          : (_ctx.codeConfirmationNotValid)
            ? (_openBlock(), _createBlock("label", {
                key: 1,
                for: 'codecheck_' + _ctx.labelId,
                class: "fs-13 label-error"
              }, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeConfirmationDoesNotMatch")), 9, ["for"]))
            : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}